import { Moon, Sun, Sparkles, Gem } from 'lucide-react';
import { useTheme, type Theme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';

const META: Record<Theme, { icon: typeof Sun; label: string }> = {
  light: { icon: Sun, label: 'Claro' },
  dark: { icon: Moon, label: 'Oscuro' },
  carnaval: { icon: Sparkles, label: 'Carnaval' },
  glass: { icon: Gem, label: 'Glass (beta)' },
};

/* Glass es beta: solo entra al ciclo para la cuenta de Carlos. */
export const GLASS_EMAIL = 'admin@forobeta.com';

/** Un solo botón: muestra el tema actual y al clic pasa al siguiente
    (cicla claro → oscuro → carnaval[→ glass solo Carlos], decidido 2026-07-01). */
export default function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  const { user } = useAuth();
  const cycle: Theme[] = user?.email === GLASS_EMAIL
    ? ['light', 'dark', 'carnaval', 'glass']
    : ['light', 'dark', 'carnaval'];
  const next = () => {
    const i = cycle.indexOf(theme);
    setTheme(cycle[(i + 1) % cycle.length] ?? 'dark');
  };
  const { icon: Icon, label } = META[theme];
  return (
    <button
      onClick={next}
      title={`Tema: ${label} — clic para cambiar`}
      aria-label={`Tema actual: ${label}. Cambiar tema`}
      className={`flex h-9 w-9 items-center justify-center rounded-lg text-content-2 ring-1 ring-line transition hover:bg-surface-2 hover:text-content ${className}`}
    >
      <Icon size={18} />
    </button>
  );
}
